import i18next from "i18next";
import { toastService } from "../../../component/common/toast-messages/toast";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import Actions from "../../actions";
import * as requestFromServer from "./walletInfoApis";

// Wallet Info -> get Wallet Info  api
export const getWalletInfoAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getWalletInfo(dataToBeSent);
  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_WALLET_INFO_LIST, {
        walletInfo: response,
      })
    );
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// Wallet Info -> get Wallet Info  api
export const givePointsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.givePoints(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// get gift card -> get gift card api
export const getGiftCardsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getGiftCards(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(
        Actions.createAction(Actions.GET_GIFT_CARD_LIST, {
          giftCards: response,
        })
      );
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// redeeme gift code -> redeeme gift code api
export const redeemeGiftCodeAction =
  (dataToBeSent, setLoading, form, setCouponCodeMessage) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.redeemeGiftCode(dataToBeSent);
    if (response) {
      toastService.success(i18next.t("GiftCardRedeemed"));
      form.setFieldsValue("gift_card_token", "");
      setCouponCodeMessage("");
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const purchaseGiftCardAction =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.purchaseGiftCard(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> validate coupon code
export const validateGiftCodeAction =
  (dataToBeSent, setLoading, setCouponCodeMessage, form) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.validateGiftCode(dataToBeSent);
    if (response) {
      toastService.success("Gift Card is applied");
      setCouponCodeMessage("Gift Card is applied");
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_GIFT_CODE, {
          validateGiftCodeData: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      toastService.error(response?.message);
      form.setFieldValue("gift_card_token", "");
      setLoading(false);
      return null;
    }
  };

// Wallet Info -> get Wallet Info  api
export const getGiftCardTransactionAction =
  (setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getGiftCardTransactionInfo();
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_GIFTCARD_INFO_LIST, {
          giftInfo: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
